import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FlushIntravenousCatheterAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-flush-intravenous-catheter-slot',
    templateUrl: './flush-intravenous-catheter-slot.component.html',
    styleUrl: './flush-intravenous-catheter-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlushIntravenousCatheterSlotComponent implements SheetSlotComponentBase {

	@Input() action!: FlushIntravenousCatheterAction;
	value = null;

	constructor() {
	}
}